var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask", attrs: { id: "MobileMenu" } }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button", "aria-label": "Close" },
              on: { click: _vm.close }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "26",
                    height: "26",
                    viewBox: "0 0 26.16 26.16"
                  }
                },
                [
                  _c("g", [
                    _c("g", [
                      _c("rect", {
                        staticStyle: { fill: "#fff" },
                        attrs: {
                          x: "-4.92",
                          y: "12.58",
                          width: "36",
                          height: "2",
                          transform: "translate(13.08 -5.42) rotate(45)"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        staticStyle: { fill: "#fff" },
                        attrs: {
                          x: "-4.92",
                          y: "12.58",
                          width: "36",
                          height: "2",
                          transform: "translate(-5.42 13.08) rotate(-45)"
                        }
                      })
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "a",
              {
                staticClass: "menu-logo mb-2 nav-center-image",
                attrs: { href: _vm.homeRoute }
              },
              [
                _c("picture", [
                  _c("source", {
                    attrs: {
                      srcset: _vm.headerLogo + ".webp",
                      type: "image/webp"
                    }
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      srcset: _vm.headerLogo + ".png",
                      type: "image/png"
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "nav-center-social",
                    attrs: {
                      src: _vm.headerLogo + ".png",
                      alt: "GAME OF THRONES: CONQUEST"
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("ul", { staticClass: "links" }, [
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  { staticClass: "nav-link", attrs: { href: _vm.homeRoute } },
                  [
                    _c("img", {
                      staticClass: "mobile-nav-image",
                      attrs: {
                        src:
                          "https://images.ctfassets.net/nwksj2ft7iku/3FaiwdJB6XN7XHVYj0yD4K/6e8f17c48134c66aa4957d0cfb85a36e/Home.png"
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item" }, [
                _c(
                  "a",
                  { staticClass: "nav-link", attrs: { href: _vm.newsRoute } },
                  [
                    _c("img", {
                      staticClass: "mobile-nav-image",
                      attrs: {
                        src:
                          "https://images.ctfassets.net/nwksj2ft7iku/6ArQrY7wqtye2Zh56jrNEx/9ba1dfa2b69a64382aa18f1da37ec755/LatestNews.png"
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stores" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showIOS,
                      expression: "showIOS"
                    }
                  ],
                  class: { show: _vm.showIOS },
                  staticStyle: { opacity: "0" },
                  attrs: {
                    href:
                      "https://apps.apple.com/us/app/game-of-thrones-conquest/id1035712810",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticClass: "app-store img-fluid nav-center-platform",
                    attrs: { src: _vm.iosLogo, alt: "" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAndroid,
                      expression: "showAndroid"
                    }
                  ],
                  class: { show: _vm.showAndroid },
                  staticStyle: { opacity: "0" },
                  attrs: {
                    href:
                      "https://play.google.com/store/apps/details?id=com.wb.goog.got.conquest",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticClass: "android img-fluid nav-center-platform",
                    attrs: { src: _vm.androidLogo, alt: "" }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "nav-center-social" }, [
              _c("div", { staticClass: "social mt-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "social-list",
                    attrs: {
                      href: _vm.facebook,
                      title: "Facebook",
                      target: "_blank",
                      rel: "noopener",
                      "aria-label": "Visit Facebook.com",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom"
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fab", "facebook"], "fixed-width": "" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "social-list",
                    attrs: {
                      href: _vm.twitter,
                      title: "X",
                      target: "_blank",
                      rel: "noopener",
                      "aria-label": "Visit X.com",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom"
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fab", "x-twitter"], "fixed-width": "" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "social-end",
                    attrs: {
                      href: _vm.discord,
                      title: "discord",
                      target: "_blank",
                      rel: "noopener",
                      "aria-label": "Visit Discord.com",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom"
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fab", "discord"], "fixed-width": "" }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }